
import { Component, Vue } from "vue-property-decorator";
import MoqupMatrice from "@/views/moqups/organigram/Matrice.vue";
import MoqupStock from "@/views/moqups/organigram/Stock.vue";

@Component({
  components: {
    MoqupMatrice,
    MoqupStock,
  },
})
export default class Organigramme extends Vue {

  private tab: "MATRICE" | "STOCK" = "MATRICE";

  private changeTabs(tab) {
    this.tab = tab;
  }
}
